import {api, handleApiError, ServiceResponse} from "../ApiClient";

export interface Club {
    id: string
    name: string
    verified: boolean
    hasPrepaidBags: boolean
}

export interface GetClubsResponse extends ServiceResponse {
    clubs?: Club[]
}

export interface ClubResponse extends ServiceResponse {
    club?: Club
}

export const ClubService = () => {

    const get = (clubId: string): Promise<ClubResponse> => {
        return api.get<Club>(`/api/1/club/${clubId}`)
            .then((resp) => {
                if (resp && resp.status === 200 && resp.data) {
                    return {
                        club: resp.data
                    }
                }

                return {
                    error: {
                        message: 'Could not get club.'
                    }
                }
            })
            .catch(handleApiError)
    };

    const getAll = (): Promise<GetClubsResponse> => {
        return api.get<Club[]>(`/api/1/clubs`)
            .then((resp) => {
                if (resp && resp.status === 200 && resp.data) {
                    return {
                        clubs: resp.data
                    }
                }

                return {
                    error: {
                        message: 'Could not get clubs.'
                    }
                }
            })
            .catch(handleApiError)
    };

    return {
        getClub: get,
        getClubs: getAll,
    }
}
